// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-popover-container {
  position: relative;
}
.info-popover-container ion-icon {
  font-size: 1.5rem;
  top: 5px;
  right: 5px;
  position: absolute;
}

ion-label {
  white-space: normal !important;
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-vip/deposit-vip.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,iBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AACR;;AAGA;EACI,8BAAA;EACA,4BAAA;AAAJ","sourcesContent":[".info-popover-container{\r\n    position: relative;\r\n\r\n    ion-icon{\r\n        font-size: 1.5rem;\r\n        top: 5px;\r\n        right: 5px;\r\n        position: absolute;\r\n    }\r\n}\r\n\r\nion-label{\r\n    white-space: normal !important;\r\n    overflow: visible !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
